import "./modalProfile.css";
import logout from "../../assets/svgs/logout.svg";
import close from "../../assets/svgs/close.svg";
import profile from "../../assets/svgs/icon-profile.svg";
import { gotoLogout } from "../../utils/authUtils";
import { useEffect, useState } from "react";
import Modal from "../../componentes/modal/modal";
import { useRoles } from "../../hooks/roles";

interface ModalProfileProps {
  onClose?: () => void;
  options: {
    nome: string;
    email: string;
  };
}

function ModalProfile({ onClose, options }: ModalProfileProps) {
  const { isTax } = useRoles();
  const [perfilUser, setPerfilUser] = useState("false");
  const [modalLogout, setModalLogout] = useState<boolean>(false);

  useEffect(() => {
    if (isTax === true) {
      setPerfilUser("Aprovador TXR");
    } else {
      setPerfilUser("Engenheiro");
    }
  }, [isTax]);

  return (
    <div className="containerModal">
      <div className="arrow-up" />
      <div className="title">
        <span className="name">{perfilUser}</span>

        <div>
          <button
            type="button"
            onClick={() => setModalLogout(true)}
            className="logoutButton"
            aria-label="Abrir modal de logout"
            >
            <img
              style={{ marginRight: 10, cursor: "pointer" }}
              width={18}
              height={18}
              src={logout}
              alt="icon logout"
            />
          </button>

          <button
            type="button"
            className="logoutButton"
            aria-label="Fechar modal de perfil"
            onClick={onClose}
          >
            <img
              style={{ marginRight: 5 }}
              src={close}
              alt="icon close"
              width={18}
              height={18}
            />
          </button>
        </div>
      </div>
      <div className="subContainer">
        <img src={profile} alt="icon-profile"/>
        <div className="detals-name">
          <span className="name" role="button">
            {options?.nome}
          </span>
          <span className="email" role="button">
            {options?.email}
          </span>
        </div>
      </div>

      {modalLogout && (
        <Modal
          titleDescriptions="Você tem certeza de que deseja sair?"
          titleModal="Aviso"
          bodyModal={
            <span style={{ marginTop: "-10px" }}>
              Você será direcionado à página de logout e poderá sair com
              segurança do sistema.
            </span>
          }
          onClose={() => setModalLogout(false)}
          onConfirm={() => gotoLogout()}
          buttonOne="Sim"
          buttonTwo="Não"
          className="modalLogouts"
        />
      )}
    </div>
  );
}
export default ModalProfile;
